module.exports = __webpack_public_path__ + "img/icon3.0f9a9982.png";